import { Link } from "react-router-dom";
import type { GuaEvent } from "@/types";
import { statusMeta } from "@/mocks/site";

export default function EventCard({ event }: { event: GuaEvent }) {
  const st = statusMeta[event.status] || statusMeta.reviewing;
  return (
    <article className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-lift hover:border-background-300">
      <Link to={`/gua/${event.id}`} className="relative block aspect-[4/3] overflow-hidden cursor-pointer">
        <img
          src={event.cover}
          alt={event.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className={`absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${st.chip}`}>
          <i className={`${st.icon} text-[13px]`} />
          {st.label}
        </span>
        <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-1 text-xs text-background-50 backdrop-blur-sm">
          <i className="ri-folder-line text-primary-300" />
          {event.catName}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-display text-base font-bold leading-snug text-foreground-950 md:text-[17px]">
          <Link to={`/gua/${event.id}`} className="transition-colors hover:text-primary-700 cursor-pointer">
            {event.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{event.summary}</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {event.tags.slice(0, 3).map((t) => (
            <span key={t} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              #{t}
            </span>
          ))}
        </div>

        <div className="mt-4 border-t border-dashed border-background-200 pt-3">
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-fire-fill text-primary-500" />
              热度 <b className="text-foreground-900">{event.heat}</b>
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-user-3-line text-accent-600" />
              {event.crowd} 在场
            </span>
            <span>更新 {event.updated}</span>
          </div>
          <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
            <div
              className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-600"
              style={{ width: `${event.heat}%` }}
            />
          </div>
        </div>

        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-foreground-400">{event.timeline.length} 个关键节点</span>
          <Link
            to={`/gua/${event.id}`}
            className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800 cursor-pointer"
          >
            进圈开吃
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </article>
  );
}